export const WEB_AWESOME_LAYOUT = 'web-awesome'
export const KIT_SPECIFIC_VERSION_LAYOUT = 'kit-specific-version'
export const V6_DOCS_LAYOUT = 'v6-docs'
export const V5_DOCS_LAYOUT = 'v5-docs'
